"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PostRequestedDoc {
}
exports.default = PostRequestedDoc;
//# sourceMappingURL=PostRequestedDoc.js.map